/*eslint-disable*/
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";
import React from "react";

export default function Footer(props) {
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent='space-between'
      px='30px'
      pb='20px'>
      <Text
        color='gray.400'
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}>
        &copy; {1900 + new Date().getYear()},{" "}
        <Text as='span'>
          {"theme made by "}
        </Text>
        <Link
          color='red.400'
          href='https://www.creative-tim.com'
          target='_blank'>
          {"Creative Tim "}
        </Link>
        &
        <Link color='red.400' href='https://www.simmmple.com' target='_blank'>
          {" Simmmple"}
        </Link>
        {". Edited by"}
        <Link color='red.400' href='https://destriusz.github.io' target='_blank'>
          {" @destriusz"}
        </Link>
        {" with ❤️ for SAFD purposes."}
      </Text>
    </Flex>
  );
}
